import { SpinService } from '../spin/service/SpinService'

export const spinService = new SpinService()
